module.exports = __webpack_public_path__ + "img/costSaving.2dfb8a2c.png";